import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SpinnerService} from '../../services/spinner.service';
import {finalize} from 'rxjs/operators';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  constructor(private spinnerService: SpinnerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('api/v1/Module/') && request.url.endsWith('UserId')) {
      return next.handle(request);
    }
    if (request.url.includes('api/v1/Maintenance')) {
      return next.handle(request);
    }
    if (request.url.includes('api/v1/News')) {
      return next.handle(request);
    }
    if (request.url.includes('https://login.motracking.ch/api/v1') || request.url.includes('api/tracking/CheckTransportStatus')) {
      return next.handle(request);
    }
    this.spinnerService.busy();
    return next.handle(request).pipe(
      finalize(() => {
        this.spinnerService.idle();
      })
    );
  }
}
